import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IProductType } from "@/typings/Props";

export const fetchProductsAsync = createAsyncThunk("products/fetchData", async () => {
  const fetchResult = await fetch("/data/products.json");
  const result = await fetchResult.json();
  return result;
});

type TProductsState = {
  loading: boolean;
  products: IProductType[];
};

const initialState: TProductsState = {
  loading: false,
  products: [],
};

export const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProductsAsync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProductsAsync.fulfilled, (state, action) => {
      state.loading = false;
      state.products = action.payload;
    });
    builder.addCase(fetchProductsAsync.rejected, (state) => {
      state.loading = false;
      console.error("[ERROR] rejected products.json");
    });
  },
});

export default productSlice.reducer;
